
import { defineComponent, nextTick, watch, ref, reactive } from 'vue'
import { useRoute } from 'vue-router'
import { useI18n } from 'vue-i18n'
import { ElAside, ElMenu, ElMenuItem } from 'element-plus'
import { MenuItem } from '@/models/Menu.model'
import { getMenuList } from '@/utils/menuList'
import PcSubmenuList from './PcSubmenuList.vue'
import { menuNameCustomFuns } from './config/pc'
import { genMenuNameShow } from './utils'
import 'element-plus/es/components/aside/style/css'
import 'element-plus/es/components/menu/style/css'
import 'element-plus/es/components/menu-item/style/css'

export default defineComponent({
  name: 'MenuPcComp',
  components: {
    'el-aside': ElAside,
    'el-menu': ElMenu,
    'el-menu-item': ElMenuItem,
    PcSubmenuList
  },
  emits: ['collapseStatusChange', 'input', 'change'],
  setup(props, { emit }) {
    const { t } = useI18n()
    const route = useRoute()
    // 菜单配置
    // todo 读接口
    const state = reactive<{
      menuList: MenuItem[]
      isCollapse: boolean
      activeIndex: string
    }>({
      menuList: [],
      // 菜单是否为收起状态
      isCollapse: false,
      // 当前选中的菜单
      activeIndex: ''
    })

    // 过滤过的可进行渲染用的菜单数据
    const menuListFiltered = ref<MenuItem[]>([])

    function genMenuListFiltered() {
      const dfs = (list: MenuItem[], level: number) => {
        const res: MenuItem[] = []

        if (list) {
          list.forEach((item: MenuItem) => {
            const newItem = { ...item }
            const { name = '' } = newItem
            if (level > 1) {
              delete newItem.icon
              delete newItem.iconActive
            }

            // 配置自定义 name 方法
            const nameCustomFun = menuNameCustomFuns[name]
            if (nameCustomFun) {
              newItem.nameCustomFun = nameCustomFun(name)
            }

            // 同时执行自定义文案渲染
            nextTick(() => genMenuNameShow(newItem))

            if (newItem.children && newItem.children.length) {
              newItem.children = dfs(newItem.children, level + 1)
            }

            // 仅当 children 不为空或 link 存在时才做为需要渲染的菜单内容返回
            if (newItem.link || (newItem.children && newItem.children.length)) {
              res.push(newItem)
            }
          })
        }

        return res
      }
      menuListFiltered.value = dfs(state.menuList, 1)
    }
    function emitCollapseStatusChange() {
      emit('collapseStatusChange', state.isCollapse)
    }
    function initCollapseStatus() {
      emitCollapseStatusChange()
    }
    function genIndexes() {
      const indexes: string[] = []
      const dfs = (list: MenuItem[]) => {
        list.forEach((item: MenuItem) => {
          if (item.link) indexes.push(item.link)
          if (item.children) dfs(item.children)
        })
      }
      dfs(state.menuList)
      return indexes
    }
    // 根据路由匹配最接近的菜单做激活
    function matchActiveIndex() {
      const path = window.location.pathname
      const fullpath = path + window.location.search + window.location.hash
      const indexes = genIndexes()

      if (indexes.includes(path)) {
        state.activeIndex = path
      } else if (indexes.includes(fullpath)) {
        state.activeIndex = fullpath
      } else {
        indexes.some((index: string) => {
          const res1 = new RegExp(index).test(path)
          const res2 = new RegExp(index).test(fullpath)
          const res = res1 || res2
          if (res) state.activeIndex = index
          return res
        })
      }
    }
    // 处理子菜单展开操作
    function handleMenuOpen(index: string) {
      const paths = index.split('-')
      let curMenu: any = { children: menuListFiltered.value }

      // 获取当前展开的具体菜单
      paths.forEach((key: string, i: number) => {
        if (curMenu.children) {
          curMenu = curMenu.children[Number(key)]
        }
      })

      // 对所展开的菜单做 show name 的更新渲染
      if (curMenu?.children) {
        curMenu.children.forEach((menu: MenuItem) => {
          genMenuNameShow(menu)
        })
      }
    }

    const jumpMenu = (link) => link && window.history.pushState({}, '', link)

    // 监听菜单展开收起切换
    const toggleMenu = () => {
      state.isCollapse = !state.isCollapse
      emitCollapseStatusChange()
    }

    getMenuList().then((menuList: MenuItem[]) => {
      state.menuList = menuList
      genMenuListFiltered()
      matchActiveIndex()
    })
    initCollapseStatus()
    matchActiveIndex()

    watch(
      () => route.path,
      () => {
        matchActiveIndex()
      }
    )

    return {
      t,
      state,
      menuListFiltered,
      jumpMenu,
      toggleMenu,
      handleMenuOpen
    }
  }
})
